import { Customer } from 'types'
import { Card } from 'antd'

interface CustomerDetailsProps {
  customer?: Customer | null
}

const CustomerDetails = ({ customer }: CustomerDetailsProps) => {
  return (
    <Card title="Customer Details">
      {customer ? (
        <>
          <p>
            <strong>Name:</strong> {customer.first_name} {customer.last_name}
          </p>
          <p>
            <strong>Address:</strong> {customer.address}
          </p>
          <p>
            <strong>City:</strong> {customer.city} {customer.zip_code}
          </p>
          <p>
            <strong>Country:</strong> {customer.country}
          </p>
        </>
      ) : (
        <div>No customer details available</div>
      )}
    </Card>
  )
}

export default CustomerDetails
